import type { FilterParameters } from "./filterMemory.ts";
import { API_BASE } from "./apiBase.ts";

function authHeaders(accessToken: string, email?: string, json = false) {
  return {
    ...(json ? { "Content-Type": "application/json" } : {}),
    Authorization: `Bearer ${accessToken}`,
    ...(email ? { "X-User-Email": email } : {}),
  };
}

export type FilterPreference = {
  resource_key: string;
  parameters: FilterParameters;
  updated_at?: string;
};

export async function getFilterPreference(
  accessToken: string,
  resourceKey: string,
  email?: string | null,
): Promise<FilterPreference | null> {
  const resp = await fetch(
    `${API_BASE}/api/me/report-filter-preferences/${encodeURIComponent(resourceKey)}`,
    {
      method: "GET",
      headers: authHeaders(accessToken, email || undefined),
      credentials: "include",
    },
  );

  if (resp.status === 204 || resp.status === 404) return null;
  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(`filter preference ${resp.status}: ${text}`);
  }

  return resp.json();
}

export async function putFilterPreference(
  accessToken: string,
  resourceKey: string,
  parameters: FilterParameters,
  email?: string | null,
) {
  const resp = await fetch(
    `${API_BASE}/api/me/report-filter-preferences/${encodeURIComponent(resourceKey)}`,
    {
      method: "PUT",
      headers: authHeaders(accessToken, email || undefined, true),
      credentials: "include",
      body: JSON.stringify({ parameters }),
    },
  );

  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(`filter preference update ${resp.status}: ${text}`);
  }

  return resp.json();
}
